import { render } from "./TermsLink.vue?vue&type=template&id=2eb49a59"
import script from "./TermsLink.vue?vue&type=script&lang=js"
export * from "./TermsLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__